import styled from 'styled-components'

export const InvestWrapper = styled.div`
  font-style: normal;
  font-weight: 500;
  padding-top: 50px;
  height: auto;
  font-family: ${({ theme }) => theme.colors.inter};
  color: #00327c;
  .invest_btn_container {
    margin: 20px 0px;
  }
  .invest-image {
    margin-top: 15px;
    height: 190px;
  }
  .invest {
    margin-top: -20px;
    width: 100%;
    .invest-title {
      font-style: normal;
      font-weight: 400;
      font-size: 34px;
      line-height: 41px;
      color: ${({ theme }) => theme.colors.black};
    }
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: ${({ theme }) => theme.colors.CardDark};
      margin-top: -20px;
      width: 80%;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        width: 90%;
      }
    }
  }

  .invest_btn.blur {
    background-color: #6e7191;
    opacity: 1;
    cursor: none;
    pointer-events: none;
  }

  .invest_img img {
    width: 100%;
    height: 190px;
    object-fit: cover;
    object-position: center;
  }

  .sector_quantity {
    display: flex;
    justify-content: space-between;
    color: #00327c;
    align-items: center;
    .sector {
      p {
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        color: #333333;
      }
      span {
        text-transform: uppercase;
        padding-left: 3px;
      }
    }
    .sector_text {
      text-transform: uppercase;
      font-weight: 600;
      font-family: ${({ theme }) => theme.colors.inter};
    }
  }

  .quantity {
    display: flex;
    width: 100px;
    justify-content: space-between;
    align-self: flex-end;
    align-items: center;
  }

  .quantity_btn {
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 600;
    color: #0d99ff;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 2px 2px rgba(50, 50, 71, 0.06),
      0px 2px 4px rgba(50, 50, 71, 0.06);
    border-radius: 8px;
  }

  .quantity_text {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    margin: 0px 8px;
    width: 55px;
    background-color: transparent;
    border: 1px solid #e0e0e0;
    filter: drop-shadow(0px 2px 2px rgba(50, 50, 71, 0.06))
      drop-shadow(0px 2px 4px rgba(50, 50, 71, 0.06));
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color: #6979f8;
  }

  .input_quantity input {
    width: 100%;
    height: 45px;
  }

  .verify_investment {
    display: flex;
    align-items: center;
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 11px;
      line-height: 13px;
      color: ${({ theme }) => theme.colors.CardDark};
      padding-top: 10px;
    }
    .check_container {
      margin-right: 10px;
    }
  }

  /* .bank_transfer_wrapper {
    display: none;
  } */
`

export const FlexContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .flex_one {
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-top: -5px;

      color: ${({ theme }) => theme.colors.CardDark};
    }
    .cost {
      color: #333333;
    }
  }
  .flex_two {
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.CardDark};
      margin-top: -5px;
      text-align: right;
    }
    .cost {
      color: #333333;
    }
  }
`
